import {gql} from 'apollo-angular';


export interface UserContactDetails {
  id: number;
  firstName: string;
  name: string;
  email: string;
  phone: string;
  userAgency: string;
  active: boolean;
  teamRoles: string[];
}

export const userContactDetails = gql`
    fragment userContactDetails on UserContactDetails {
        id
        firstName
        name
        email
        phone
        teamRoles
    }
`;
